import React from "react";
import { strings } from "../../Translations/strings";
import "./PrivacyPolicy.scss";
import NavProducts from "../../Marketplace/NavProducts/NavProducts";
import Footer from "../../Common/Footer/Footer";

const PrivacyPolicy = () => {
  return (
    <>
      <NavProducts />
      <div className="privacy-policy-page">
        <div className="container">
          <div className="privacy-policy-content">
            <h1 className="page-title">{strings.nav_privacy_policy_label}</h1>
            <div className="content-section">
              <div className="policy-header">
                <h2 className="policy-title">Izjava o primjenjivosti politike privatnosti</h2>
              </div>

              <div className="policy-section">
                <h3>1. Uvod</h3>
                <p>
                  Partner mikrokreditna fondacija (u daljem tekstu: Partner) posvećena je zaštiti privatnosti i zaštiti ličnih podataka 
                  klijenata, sudužnika, radnika i drugih fizičkih lica sa kojima ostvaruje poslovnu saradnju.
                </p>
                <p>
                  Ova Izjava o primjenjivosti politike privatnosti definiše način na koji Partner (u daljem tekstu: „mi", „nas" ili „naše") 
                  prikuplja, obrađuje, pohranjuje i štiti lične podatke korisnika svojih usluga i posjetilaca web stranice partner.ba (u 
                  daljem tekstu: "vi", "vaše", "vama"), u skladu sa Zakonom o zaštiti ličnih podataka BiH ("Službeni glasnik" BiH, broj: 
                  12/25) kao i drugih relevantnih važećih propisa koji uređuju ovu oblast.
                </p>
                <p>
                  Partner kao kontrolor ličnih podataka ima obavezu da omogući nosiocima podataka pristup svim bitnim informacijama 
                  o obradi njihovih podataka te da ih redovno informiše o njihovim pravima i svrsi obrade.
                </p>
                <p>
                  Bilo koji vaš lični podatak nećemo koristiti, dijeliti ili objaviti bilo kojoj trećoj strani osim kako je opisano u ovom 
                  dokumentu.
                </p>
              </div>

              <div className="policy-section">
                <h3>2. Definicije pojmova</h3>
                <p>U nastavku su objašnjeni ključni pojmovi koji se koriste u ovoj Politici, u skladu sa Zakonom o zaštiti ličnih podataka.</p>
                <ul>
                  <li><strong>Nosilac podataka</strong> je fizičko lice čiji je identitet utvrđen ili čiji se identitet može utvrditi, posredno ili neposredno, posebno pomoću identifikatora kao što su ime, identifikacioni broj, podaci o lokaciji, mrežni identifikator ili pomoću jednog ili više faktora svojstvenih za fizički, fiziološki, genetski, mentalni, ekonomski, kulturni ili društveni identitet tog lica.</li>
                  <li><strong>Lični podatak</strong> je svaki podatak koji se odnosi na fizičko lice čiji je identitet utvrđen ili se može utvrditi.</li>
                  <li><strong>Kontrolor podataka</strong> je fizičko ili pravno lice, javni organ ili nadležni organ koji samostalno ili s drugim određuje svrhe i sredstva obrade ličnih podataka. Kada su svrhe i sredstva takve obrade utvrđeni zakonom, kontrolor podataka ili posebni kriteriji za njegovo imenovanje propisuju se zakonom.</li>
                  <li><strong>Obrađivač podataka</strong> je fizičko ili pravno lice, javni organ koji obrađuje lične podatke u ime kontrolora podataka.</li>
                  <li><strong>Treća strana</strong> znači fizičko ili pravno lice, javni organ, Agencija ili drugo tijelo koje nije nosilac podataka, kontrolor podataka, obrađivač i lica koja su ovlaštena za obradu ličnih podataka pod neposrednom nadležnošću kontrolora podataka ili obrađivača.</li>
                  <li><strong>Saglasnost</strong> nosioca podataka je svako dobrovoljno, posebno, informirano i nedvosmisleno izražavanje volje nosioca podataka kada on izjavom ili jasnom potvrdnom radnjom daje pristanak za obradu ličnih podataka koji se na njega odnose.</li>
                  <li><strong>Povreda ličnih podataka</strong> je kršenje sigurnosti koje dovodi do slučajnog ili nezakonitog uništenja, gubitka, izmjene, neovlaštenog otkrivanja ili pristupa ličnim podacima koji su preneseni, čuvani ili na drugi način obrađivani.</li>
                  <li><strong>Poslovni partner</strong> označava pravno lice koje sarađuje sa Partnerom radi pružanja dodatnih pogodnosti, proizvoda ili usluga klijentima Partnera, bilo u ime Partnera ili u sopstvenoj ponudi.</li>
                </ul>
              </div>

              <div className="policy-section">
                <h3>3. Podaci o kontroloru</h3>
                <div className="contact-info">
                  <p><strong>Partner mikrokreditna fondacija</strong></p>
                  <p>Adresa: 15 maj bb, 75000 Tuzla</p>
                  <p>JIB: 4209417070002</p>
                  <p>Web: <a href="https://www.partner.ba" target="_blank" rel="noopener noreferrer">www.partner.ba</a></p>
                </div>
              </div>

              <div className="policy-section">
                <h3>4. Podaci o ovlaštenom licu za zaštitu podataka</h3>
                <p>
                  Partner će razmotriti vaše upite u vezi obrade ličnih podataka i omogućiti vam ostvarivanje vaših prava propisanih 
                  Zakonom o zaštiti ličnih podataka. Nosilac funkcije za zaštitu ličnih podataka je Službenik za zaštitu ličnih podataka, 
                  dostupan je putem kontakata navedenih u nastavku:
                </p>
                <div className="contact-info">
                  <div className="contact-item">
                    <strong>Email:</strong> <a href="mailto:sszlp@partner.ba">sszlp@partner.ba</a>
                  </div>
                  <div className="contact-item">
                    <strong>Telefon:</strong> +387 35 300 250
                  </div>
                  <div className="contact-item">
                    <strong>Adresa:</strong> 15 maj bb, 75000 Tuzla, Bosna i Hercegovina
                  </div>
                </div>
                <p>
                  Partner je dužan da odgovori na vaš zahtjev u roku od 30 dana od dana njegovog prijema, uz mogućnost produženja 
                  roka do 60 dana kada je to opravdano, o čemu ćete kao nosilac podataka biti pravovremeno obaviješteni. Pružanje 
                  ove usluge ćemo vršiti bez naknade. Ako podnesete zahtjev elektronskim putem, odgovor će vam biti dostavljen 
                  elektronskim putem, izuzev ukoliko u svom zahtjevu ne navedete drugi vid komunikacije.
                </p>
                <p>
                  Ukoliko ne dobijete odgovor u navedenim rokovima, ili niste zadovoljni sa istim, možete se obratiti Agenciji za zaštitu 
                  ličnih podataka ili svoja prava možete tražiti pred nadležnim sudom ili putem drugih pravnih sredstava.
                </p>
              </div>

              <div className="policy-section">
                <h3>5. Vrste podataka koje prikupljamo i obrađujemo</h3>
                <p>
                  Tokom poslovnog odnosa prikupljamo različite vrste informacija, a ovaj dokument se odnosi na obradu podataka bez 
                  obzira da li se ona obavlja automatizirano ili neutomatizirano.
                </p>
                <p>Vrsta podataka koje možemo prikupljati, ali se ne ograničavamo na istu, su:</p>
                <ul>
                  <li>identifikacioni podaci (ime, prezime, JMBG, podaci iz ličnih dokumenata),</li>
                  <li>sociodemografski podaci (npr. pol, dob, obrazovanje, zaposlenje, imovina, prihodi, primanja, informacije o poslovanju),</li>
                  <li>kontakt podaci (adresa, telefon, e-mail),</li>
                  <li>podaci o poslovnom odnosu (npr. transakcije, korišteni kanali komunikacije, ugovori, proizvodi),</li>
                  <li>tehnički podaci (IP adresa vašeg uređaja, stranice unutar naše usluge koje posjećujete, vrijeme i datum vaše posjete, vrijeme koje ste proveli na tim stranicama, kao i druge dijagnostičke informacije, kolačići).</li>
                </ul>
                <p>Podaci se mogu prikupljati putem:</p>
                <ul>
                  <li>Ugovara.</li>
                  <li>E-mail komunikacije, telefonskih, video razgovora i razgovora u našim poslovnim prostorijama.</li>
                  <li>Istraživanja zadovoljstva korisnika i promotivnih aktivnosti.</li>
                  <li>Putem društvenih mreža i javno dostupnih informacija na njima.</li>
                  <li>Putem web stranice www.partner.ba.</li>
                </ul>
              </div>

              <div className="policy-section">
                <h3>6. Svrha obrade podataka</h3>
                <p>
                  Svi podaci se obrađuju u skladu sa principima zakonitosti, transparentnosti i ograničenja svrhe. 
                  Obrada se vrši na osnovu: saglasnosti nosioca podataka, ugovornih obaveza, zakonskih propisa i legitimnog interesa 
                  Partnera. Podaci se osim ličnog preuzimanja od nosioca podataka, mogu pribavljati i iz državnih registara, drugih 
                  institucija i pravnih lica, u skladu sa zakonom ili zaključenim pravnim poslom.
                </p>
                <p>
                  Vaša saglasnost sa obavijesti o privatnosti podataka predstavlja saglasnost sa ovom politikom, kao i vaše podnošenje 
                  potrebnih informacija, predstavlja vaš pristanak na ustupanje istih.
                </p>
                <p>
                  U slučaju da kao nosilac podataka odbijete da dostavite informacije koje su neophodne za izvršenje ugovora, Partner 
                  zadržava pravo da vam odbije pružanje traženih usluga.
                </p>
                <p>
                  U određenim situacijama, Partner može obrađivati lične podatke na osnovu izričite i dobrovoljno date saglasnosti vas 
                  kao nosioca podataka. To se naročito odnosi na: slanje promotivnih ponuda i informacija o proizvodima i uslugama 
                  putem različitih komunikacijskih kanala; izradu personalizovanih ponuda; provođenje istraživanja tržišta i ispitivanja 
                  zadovoljstva klijenata. Davanje saglasnosti za ove svrhe je dobrovoljno i odbijanje neće uticati na mogućnost sklapanja 
                  ili realizacije ugovornih odnosa s Partnerom. Kao nosilac podataka imate pravo u svakom trenutku povući saglasnost, 
                  a povlačenje ne utiče na zakonitost obrade koja je prethodno izvršena.
                </p>
                <p>
                  Partner može obrađivati lične podatke kada je to neophodno za ostvarenje legitimnih interesa, uz uslov da ti interesi ne 
                  narušavaju prava i slobode nosioca podataka. Primjeri takvih obrada su u svrhu:
                </p>
                <ul>
                  <li>upravljanja kreditnim, operativnim, sigurnosnim i reputacijskim rizicima;</li>
                  <li>unaprijeđenja usluga, proizvoda i korisničkog iskustva;</li>
                  <li>zaštite objekata, imovine i radnika (uključujući videonadzor);</li>
                  <li>internog izvještavanja i odvijanja administrativnih procesa unutar Partnera;</li>
                  <li>obezbjeđenja informatičke sigurnosti i komunikacijskih sistema;</li>
                  <li>ograničenog direktnog marketinga, ako nosilac podataka nije uložio prigovor.</li>
                </ul>
                <p>
                  Partner može obrađivati lične podatke kada je to neophodno za zaštitu svojih zakonitih prava i legitimnih interesa, kao i 
                  prava trećih strana, uz uslov da ti interesi ne narušavaju prava i slobode nosioca podataka. Primjeri obrade podataka 
                  su: sprovođenje pravnih postupaka, naplata dospjelih potraživanja ili postupanja po zahtjevima nadležnih organa.
                </p>
              </div>

              <div className="policy-section">
                <h3>7. Vremenski period čuvanja ličnih podataka</h3>
                <p>
                  Lični podaci se čuvaju sve dok postoji aktivan poslovni odnos. Po prestanku poslovnog odnosa, podaci se čuvaju u 
                  skladu sa propisanim rokovima a nakon toga uništavaju, izuzev u slučajevima kada se zbog zakonskih propisa, 
                  legitimnih interesa (npr. vođenja sudskih sporova ili postojanja važeće saglasnosti nosioca podataka), čuvaju i nakon 
                  isteka poslovnog odnosa.
                </p>
              </div>

              <div className="policy-section">
                <h3>8. Prava nosioca podataka</h3>
                <p>
                  Nosilac podataka čije podatke obrađuje Partner, u skladu sa Zakonom o zaštiti ličnih podataka, ima pravo na pristup, 
                  ispravku, brisanje, ograničenje obrade, prenos podataka, prigovor i pravo da ne budu predmet automatizovanog 
                  odlučivanja.
                </p>
                <p>Kao nosilac podataka, imate sljedeća prava:</p>
                <ul>
                  <li><strong>Pravo na pristup podacima</strong> – pravo da dobijete potvrdu da li Partner obrađuje vaše lične podatke i da vam se omogući uvid u te podatke;</li>
                  <li><strong>Pravo na ispravku</strong> – pravo da tražite ispravku netačnih i dopunu nepotpunih ličnih podataka koji se odnose na vas;</li>
                  <li><strong>Pravo na brisanje</strong> – pravo da tražite brisanje vaših ličnih podataka, u skladu sa uslovima propisanim zakonom;</li>
                  <li><strong>Pravo na ograničenje obrade</strong> – pravo da zahtijevate privremeno ograničenje obrade u određenim slučajevima;</li>
                  <li><strong>Pravo na prigovor</strong> – pravo da u svakom trenutku uložite prigovor na obradu ličnih podataka koja se zasniva na legitimnom interesu Partnera;</li>
                  <li><strong>Pravo na povlačenje saglasnosti</strong> – ukoliko se obrada vrši na osnovu saglasnosti, imate pravo da tu saglasnost povučete u bilo kojem trenutku, bez negativnih posljedica;</li>
                  <li><strong>Pravo na prenosivost podataka</strong> – u slučajevima predviđenim zakonom, imate pravo da podatke koje ste stavili na raspolaganje Partneru dobijete u strukturiranom i čitljivom formatu i da ih prenesete drugom kontroloru.</li>
                  <li><strong>Pravo na žalbu</strong> – ukoliko smatrate da je došlo do povrede vaših prava, možete podnijeti prigovor Agenciji za zaštitu ličnih podataka BiH.</li>
                </ul>
                <p>
                  Partner u odnosu na poslovni odnos s nosiocem podataka ne provodi automatizovano pojedinačno donošenje odluka 
                  koje bi proizvelo pravne efekte s negativnim posljedicama za vas kao nosioca podataka.
                </p>
                <p>
                  U slučaju automatizovanog donošenja odluke, kao nosilac podataka imate pravo da se na vas ne odnosi odluka koja 
                  se temelji isključivo na automatizovanoj obradi, imate pravo da iznesete svoj stav ili osporite odluku nakon što ste 
                  prethodno zatražiti pojašnjenje od Partnera.
                </p>
                <p>
                  Za ostvarivanje prava, korisnici se mogu obratiti putem e-maila: <a href="mailto:sszlp@partner.ba">sszlp@partner.ba</a>.
                </p>
              </div>

              <div className="policy-section">
                <h3>9. Sigurnost podataka</h3>
                <p>
                  Partner primjenjuje tehničke i organizacione mjere zaštite, uključujući enkripciju, kontrolu pristupa, sigurnosne kopije i 
                  redovno testiranje otpornosti sistema, sve sa ciljem da se osigura povjerljivost, integritet i dostupnost korisničkih 
                  podataka.
                </p>
                <p>
                  Preduzimat ćemo sve razumne mjere da osiguramo zadovoljavajući stepen sigurnosti, ali vam skrećemo pažnju da ne 
                  postoji vrsta prenosa podataka preko Interneta ili bilo koja vrsta elektronske pohrane podataka koja pruža 100% 
                  apsolutnu zaštitu, tako da ne možemo garantovati apsolutnu sigurnost.
                </p>
                <p>
                  U slučaju da kao Kontrolor podataka dođemo do saznanja da je došlo do povrede ličnih podataka i procijenimo da bi 
                  povreda ličnog podatka mogla prouzrokovati visok rizik za vaša prava i slobode, dostavit ćemo informaciju vama i 
                  Agenciji za zaštitu ličnih podataka.
                </p>
              </div>

              <div className="policy-section">
                <h3>10. Tajnost podataka</h3>
                <p>
                  Prilikom posjete web stranici, vaši lični podaci ostaju tajni, osim ukoliko dobrovoljno ne želite da ih otkrijete. 
                  Podaci o nosiocima podataka predstavljaju poslovnu tajnu i povjerljive informacije u skladu s propisima koji uređuju 
                  sektor mikrofinansija. Pristup tim podacima moguć je isključivo u okviru ovlaštenja i dodijeljenih prava pristupa.
                </p>
                <p>
                  Na određenim mjestima unutar www.partner.ba stranica i u određeno vrijeme, Partner prikuplja lične podatke. 
                  Pomenuti podaci se koriste u svrhu kontakta i evidentiranja korisnika ove web stranice i u svrhu statističke obrade 
                  posjećenosti ove stranice.
                </p>
              </div>

              <div className="policy-section">
                <h3>11. Prijenos podataka trećim stranama</h3>
                <p>
                  Partner može dijeliti podatke, u skladu sa zakonskim propisima. Lični podaci mogu biti proslijeđeni trećim stranama, 
                  kako u zemlji tako i u inostranstvu, pod sljedećim uslovima:
                </p>
                <ul>
                  <li>kada je to predviđeno zakonom, a što uključuje i obradu zahtjeva zakonodavnih, regulatornih ili izvršnih organa, ili nadležnih organa (u cilju istraživanja ili sprečavanja kaznenog djela).</li>
                  <li>na osnovu ugovora sa nosiocem podataka i</li>
                  <li>uz saglasnost nosioca podataka.</li>
                </ul>
                <p>
                  Primaoci ličnih podataka su radnici Partnera, obrađivači s kojima Partner ima zaključen ugovor o obradi podataka, kao 
                  i druga povezana pravna lica, koja na osnovu važećih zakona, ugovornih obaveza ili profesionalnih dužnosti imaju 
                  pristup ličnim podacima. Svi navedeni subjekti obavezni su čuvati povjerljivost podataka u skladu sa zakonom i 
                  internim aktima Partnera.
                </p>
                <p>
                  Kao nosilac podataka, imate pravo na informacije o kategorijama primalaca, partnerima i vanjskim obrađivačima, 
                  putem kontakta sa Službenikom za zaštitu ličnih podataka (<a href="mailto:sszlp@partner.ba">sszlp@partner.ba</a>).
                </p>
              </div>

              <div className="policy-section">
                <h3>12. Kolačići i praćenje</h3>
                <p>
                  Web stranica koristi kolačiće kako bi smo pratili aktivnosti na našoj web stranici s ciljem poboljšanja funkcionalnosti. 
                  Korisnici mogu upravljati postavkama kolačića putem preglednika.
                </p>
                <p>
                  Statistički programi nam omogućavaju utvrđivanje onih podataka koji najviše ili najmanje zanimaju naše korisnike, 
                  vrste informacija koje je potrebno uvesti, efikasnost strukture naše web stranice i posjećenost iste.
                </p>
                <p>
                  Ako se nalazite izvan Bosne i Hercegovine i pristanete da nam ustupite informacije, vaši podaci će biti obrađivani u 
                  Bosni i Hercegovini.
                </p>
              </div>

              <div className="policy-section">
                <h3>13. Veze na druge Internet stranice</h3>
                <p>
                  Naša usluga može sadržavati veze na druge Internet stranice kojima ne upravljamo mi. Ako kliknete na vezu prema 
                  Internet stranici trećeg lica, bićete upućeni na Internet stranicu trećeg lica. Mi vam preporučujemo da se upoznate sa 
                  Politkom privatnosti svake Internet stranice koju posjećujete.
                </p>
                <p>
                  Mi nemamo kontrolu niti preuzimamo odgovornost za sadržaj, politike privatnosti ili prakse koje primjenjuju Internet 
                  stranice trećih lica.
                </p>
              </div>

              <div className="policy-section">
                <h3>14. Privatnost djece</h3>
                <p>
                  Partner ne ulazi u poslovne odnose sa osobama mlađim od 18 godina starosti („djeca"). Ukoliko objavljujemo 
                  informacije o djeci mlađoj od 18 godina starosti obavezno pribavljamo prethodnu saglasnost roditelja ili skrbnika.
                </p>
                <p>
                  Ako ste vi roditelj ili skrbnik i svjesni ste da su vaša djeca nama ustupila svoje lične podatke, molimo da nas 
                  kontaktirate. Ako mi dođemo do saznanja da smo prikupili lične podatke od djece bez uvida ili saglasnosti roditelja, mi 
                  ćemo poduzeti mjere kako bismo navedene podatke uklonili sa naših stranica.
                </p>
              </div>

              <div className="policy-section">
                <h3>15. Izmjene politike</h3>
                <p>
                  Zadržavamo pravo da možemo bilo kada i bez prethodnog obavještenja klijenta promijeniti Politiku privatnosti. 
                  Sve izmjene će biti objavljene na web stranici, te vam preporučujemo da povremeno pregledate Politiku o privatnosti 
                  kako biste se upoznali sa izmjenama.
                </p>
              </div>

              <div className="policy-footer">
                <p className="effective-date">
                  <strong>Izjava o primjenjivosti politike privatnosti stupa na snagu: 04.10.2025.</strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PrivacyPolicy;
